import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import LoadingPage from './@2026/LoadingPage';
import useAppInit from '../hooks/useAppInit';

/**
 * Observer wrapper component.
 *
 * Responsibilities:
 * - Initializes core application state (Auth, User Profile) via `useAppInit`.
 * - Shows a global `LoadingPage` while the app is preparing.
 * - Manages global SEO tags and favicon via `Helmet`.
 *
 * @component
 */
const Observer = ({ children }) => {
  const { isInitializing } = useAppInit();

  if (isInitializing) {
    return <LoadingPage />;
  }

  return (
    <>
      <Helmet>
        <link rel="icon" href="/dh-icons/favicon.ico" />
      </Helmet>
      {children}
    </>
  );
};

Observer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Observer;
